import React from "react";
import Conversation from "./Conversations";
import Search from "./Search";
import CreatePost from "./CreatePost";

import categories from "../../helpers/categories";
import { ENDPOINT_POSTS } from "../../helpers/endpoints";
import axios from "../../helpers/axios";
import { useSelector } from "react-redux";
export default function Switch(props) {
  const { userId } = useSelector(state => ({
    ...state.User
  }));
  const [data, setData] = React.useState();
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    axios.get(ENDPOINT_POSTS(userId)).then(({ data }) => {
      if (data) setData(data);
    });
    setLoading(false);
  }, [userId]);
  return (
    <div className="switch">
      <Conversation {...props} posts={data && data} />
      <Search {...props} categories={categories} />
      <CreatePost {...props} categories={categories} />
    </div>
  );
}
